import React from "react";
import { Route, Switch } from "react-router-dom";
import MetaData from "../../../CMS/meta-data";

export default () => (
  <Switch>
    <Route path="/meta-data" component={MetaData} />
  </Switch>
);
